import { createContext, useContext, useState, useEffect } from 'react';
import { getSystemStatus, setMaintenanceHandler } from '../services/api';

const MaintenanceContext = createContext(null);

/**
 * Tracks killswitch/maintenance-mode state across the app. Checks status once on mount,
 * then stays reactive to any in-flight request that surfaces a 503/MAINTENANCE_MODE
 * response via the api.js interceptor.
 */
export function MaintenanceProvider({ children }) {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    getSystemStatus()
      .then((status) => {
        setMaintenanceMode(status.maintenanceMode);
        setMessage(status.message || '');
      })
      .catch(() => {
        // Fails open — if the status check itself can't be reached, don't block the app.
      });

    setMaintenanceHandler((detectedMessage) => {
      setMaintenanceMode(true);
      setMessage(detectedMessage || '');
    });

    return () => setMaintenanceHandler(null);
  }, []);

  const value = { maintenanceMode, message };

  return <MaintenanceContext.Provider value={value}>{children}</MaintenanceContext.Provider>;
}

/** Hook to access maintenance state. Must be used inside <MaintenanceProvider>. */
export function useMaintenance() {
  const ctx = useContext(MaintenanceContext);
  if (!ctx) throw new Error('useMaintenance must be used within MaintenanceProvider');
  return ctx;
}

export default MaintenanceContext;